import { Component } from '@angular/core';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  selector: 'vnm-notification-bar',
  templateUrl: './notification-bar.component.html',
  styleUrls: ['./notification-bar.component.scss']
})
export class NotificationBarComponent {
  constructor(public userService: CurrentUserService) {}
}
